import axios from "./axios";

export const loginUser = async (email, password) => {
  const response = await axios.post('/login/', {
    email,
    password,
  });
  return response.data;
};

export async function registerUser(email, username, password) {

  const response = await axios.post('/register/', {
    email,
    username,
    password,
  });
  return response.data;
}
